import React from "react";

const PlaceholderFormInner = () => {
   return (
      <div className='form animated-background'>
         <form action='#' method='post' id='search-form' autoComplete='off'>
            <div className='fields'>
               <div className='field'>
                  <label htmlFor='location' className='pos-relative'>
                     From
                     <div className='select-wrap'>
                        <input
                           required=''
                           data-validity='0'
                           className='filtered-select'
                           type='search'
                           name='location'
                           id='location'
                           autoComplete='off'
                           placeholder='Country, city or airport'
                           defaultValue=''
                        />
                        <ul className='select-dropdown'>
                           <li className='option'>Mafia Island</li>
                           <li className='option'>Serengeti Sasakwa</li>
                           <li className='option'>Mombasa</li>
                           <li className='option'>Kigali</li>
                           <li className='option'>Serengeti Grumeti</li>
                           <li className='option'>Pemba Island</li>
                           <li className='option'>Bukoba</li>
                           <li className='option'>Tarime</li>
                           <li className='option'>Serengeti Lobo</li>
                           <li className='option'>Entebbe</li>
                           <li className='option'>Tanga</li>
                           <li className='option'>Zanzibar</li>
                           <li className='option'>Serengeti Lamai</li>
                           <li className='option'>Kilimanjaro</li>
                           <li className='option'>Dodoma</li>
                           <li className='option'>Arusha</li>
                           <li className='option'>Kuro Ranger Post</li>
                           <li className='option'>Migori</li>
                           <li className='option'>Serengeti - Seronera</li>
                           <li className='option'>Dar es Salaam</li>
                           <li className='option'>Serengeti South</li>
                           <li className='option'>Mwanza</li>
                           <li className='option'>Serengeti Kogatende</li>
                           <li className='option'>Iringa</li>
                           <li className='option'>Serengeti Wasso</li>
                           <li className='option'>Lake Manyara</li>
                           <li className='option'>Mwiba</li>
                        </ul>
                     </div>
                  </label>
               </div>
               <div className='field '>
                  <label htmlFor='destination' className='pos-relative'>
                     To
                     <div className='select-wrap'>
                        <input
                           required=''
                           data-validity='0'
                           className='filtered-select'
                           type='search'
                           name='destination'
                           id='destination'
                           autoComplete='off'
                           placeholder='Country, city or airport'
                           defaultValue=''
                        />
                        <ul className='select-dropdown'>
                           <p className='p-1'>No record(s) found</p>
                        </ul>
                     </div>
                  </label>
               </div>
               <div className='date-from-to-wrap pos-relative'>
                  <div className='field pos-relative'>
                     <label htmlFor='departure_date' className='label from'>
                        Depart
                        <input
                           required=''
                           className='date'
                           type='text'
                           name='departure_date'
                           id='departure_date'
                           placeholder='Add date'
                           defaultValue=''
                        />
                     </label>
                  </div>
                  <div className='field pos-relative'>
                     <label htmlFor='return_date' className='label to'>
                        Return
                        <input
                           required=''
                           className='date'
                           type='text'
                           name='return_date'
                           id='return_date'
                           placeholder='Add date'
                           defaultValue=''
                        />
                     </label>
                  </div>
               </div>
               <div className='field'>
                  <label className='multi-items-select pos-relative' id='multi-items-select'>
                     <span>Travellers</span>
                     <div className='select-wrap'>
                        <input
                           required=''
                           name='travellers'
                           className='select-trigger'
                           placeholder='Please select'
                           defaultValue=''
                        />
                        <ul className='multi-items-dropdown' id='multi-items-dropdown'>
                           <li>
                              <div className='description'>
                                 <p>International adults</p>
                                 <span>12+ years</span>
                              </div>
                              <div className='count'>
                                 <button type='button'>-</button>
                                 <input required='' name='adults' type='text' min='0' readOnly='' defaultValue='0' />
                                 <button type='button'>+</button>
                              </div>
                           </li>
                           <li>
                              <div className='description'>
                                 <p>International children</p>
                                 <span>2 to 12</span>
                              </div>
                              <div className='count'>
                                 <button type='button'>-</button>
                                 <input required='' name='children' type='text' min='0' readOnly='' defaultValue='0' />
                                 <button type='button'>+</button>
                              </div>
                           </li>
                           <li>
                              <div className='description'>
                                 <p>Resident adults</p>
                                 <span>12+ years</span>
                              </div>
                              <div className='count'>
                                 <button type='button'>-</button>
                                 <input required='' name='adultsRes' type='text' min='0' readOnly='' defaultValue='0' />
                                 <button type='button'>+</button>
                              </div>
                           </li>
                           <li>
                              <div className='description'>
                                 <p>Resident children</p>
                                 <span>2 to 12</span>
                              </div>
                              <div className='count'>
                                 <button type='button'>-</button>
                                 <input
                                    required=''
                                    name='childrenRes'
                                    type='text'
                                    min='0'
                                    readOnly=''
                                    defaultValue='0'
                                 />
                                 <button type='button'>+</button>
                              </div>
                           </li>
                           <li className='flex'>
                              <button type='button' className='btn btn-apply flex w-full'>
                                 Apply
                              </button>
                           </li>
                        </ul>
                     </div>
                  </label>
               </div>
            </div>
            <button className='btn' type='button'>
               Search
            </button>
         </form>
      </div>
   );
};

PlaceholderFormInner.propTypes = {};

export default PlaceholderFormInner;
